export default __webpack_public_path__ + "static/media/JS5B.5743d33d.jpg";